<template>
  <div class="container">
    <h1 class="title">{{deviceName}}-火灾报警控制器操作台({{deviceVersion | dic("SENU095")}} )</h1>
    <div class="containerBorder">
      <!-- left -->
      <div class="leftFire">
        <div class="top">
          <div class="topB">
            <div style="margin-rigth:15px"
                 class="fireT">
              <span class="checked"></span>
              <span>火警</span>
            </div>
            <div class="fireT">
              <span class="checked"></span>
              <span>启动</span>
            </div>
          </div>
        </div>
        <div class="center">
          <div v-for="item in leftList"
               class="light"
               :class="item"
               :key="item">
            <span class="checked"></span>
            <span>{{item}}</span>
          </div>
        </div>
        <div class="bottom">
          <img src="./img/组 5859.png"
               alt="">
        </div>
      </div>
      <div class="rightFire">
        <!-- rigth-t -->
        <div class="rTop">
          <div>
            {{respondText}}
          </div>
        </div>
        <!-- rigth-b -->
        <div class="rCenter">
          <div style="display:flex;flex-direction: row;justify-content: space-between">
            <div class="fB ctl-btn"
                 name="53">F1</div>
            <div class="fB ctl-btn"
                 name="54">F2</div>
            <div class="fB ctl-btn"
                 name="55">F3</div>
            <div class="fB ctl-btn"
                 name="56">F4</div>
            <div class="fB ctl-btn"
                 name="57">F5</div>
            <div class="fB ctl-btn"
                 name="58">F6</div>
          </div>
        </div>
        <div class="rbottom">
          <div class="keyBoard">
            <div v-for="item in rightList"
                 class="rlight ctl-btn"
                 :name="item.id"
                 :style="{
                background:item.id>4&&item.id<9?'linear-gradient(180deg, #FA8943 0%, #7D4522 100%)':''
            }"
                 :key="item.id">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="keyBoard2">
            <div class="f ctl-btn"
                 name="1">复位</div>
            <div class="j ctl-btn"
                 :class="deviceVersion==6?'nj':''"
                 name="49">检查</div>
            <div class="f ctl-btn "
                 name="2">消音</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './minx';
import { Dic } from '$utils'
export default {
  mixins: [mixin],
  props: {
    deviceName: {
      type: String,
      default: () => {
        return ""
      }
    },
    deviceVersion: {
      type: String,
      default: () => {
        return ""
      }
    }
  },
  data () {
    return {
      leftList: [
        "监管报警",
        "故障",
        "启动延时",
        "反馈",
        "主电运行",
        "屏蔽",
        "备电运行",
        "消音",
        "手动报警",
        "自检",
        "系统故障",
        "运行",
      ],
      rightList: [
        { name: "1..", id: 10 },
        { name: "2abc", id: 11 },
        { name: "3deft", id: 12 },
        { name: "功能", id: 50 },
        { name: "上", id: 5 },
        { name: "取消", id: 4 },
        { name: "4ghi", id: 13 },
        { name: "5jkl", id: 14 },
        { name: "6mno", id: 15 },
        { name: "左", id: 7 },
        { name: "确定", id: 3 },
        { name: "右", id: 8 },
        { name: "7pqrs", id: 16 },
        { name: "8tuv", id: 17 },
        { name: "9wxyz", id: 18 },
        { name: "中/英", id: 52 },
        { name: "下", id: 6 },
        { name: "自定义", id: 48 },
        { name: "*", id: 19 },
        { name: "0", id: 9 },
        { name: "#=", id: 45 },
        { name: "声光启", id: 46 },
        { name: "声光停", id: 47 },
        { name: "联动", id: 51 },
      ],
      controlType: "1"
    }
  },
  mounted () {
  },
}
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.checkedIng {
  @include set_theme_color(color, main-button-bgcolor);
}
.ctl-btn {
  &:hover {
    opacity: 0.6 !important;
    cursor: pointer;
  }
}
.container {
  width: 100%;
  height: 65vh;
  padding: 10px;
  .title {
    font-size: 18px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 20px;
  }
  .containerBorder {
    width: 100%;
    height: 90%;
    border-radius: 15px;
    background: #383838;
    box-shadow: 0px 0px 0px 10px rgb(123, 123, 123);
    -webkit-box-shadow: 0px 0px 0px 10px rgb(123, 123, 123);
    -moz-box-shadow: #d4d2d2 0px 0px 10px;
    display: flex;
    padding: 10px;
    .leftFire {
      width: 32%;
      .top {
        align-items: center;
        display: flex;
        height: 20%;
        justify-content: center;
        .topB {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 153px;
          height: 51px;
          background: #383838;
          border: 1px solid #858585;
          opacity: 1;
          border-radius: 7px;
        }
      }
      .center {
        height: 56%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .light {
          margin-bottom: 20px;
          margin-right: 20px;
        }
      }
      .bottom {
        height: 20%;
        img {
          width: 80%;
          height: 100%;
        }
      }
      .checked {
        display: inline-block;
        width: 10px;
        height: 10px;
        background: rgb(0, 158, 85);
        margin-right: 15px;
        border-radius: 10px;
        margin: 0px 10px;
        border-radius: 50px;
        box-shadow: 0px 0px 0px 3px #fff;
        -webkit-box-shadow: 0px 0px 0px 3px #fff;
        -moz-box-shadow: #fff 0px 0px 3px;
      }
      .rChecked {
        // background: rgb(0, 158, 85);
        background: red;
      }
      .gChecked {
        background: rgb(123, 123, 123);
      }
    }
    .rightFire {
      margin-left: 10px;
      width: 65%;
      .rTop {
        width: 100%;
        height: 42%;
        padding: 10px;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #adbfb2;
          height: 100%;
          border-radius: 15px;
          box-shadow: 0px 0px 0px 6px #000000;
          -webkit-box-shadow: 0px 0px 0px 6px #000000;
          -moz-box-shadow: #000000 0px 0px 6px;
        }
      }
      .rCenter {
        margin: 6% 0;
        .fB {
          width: 60px;
          height: 28px;
          line-height: 28px;
          margin-right: 5px;
          border: 1px solid #292929;
          background: linear-gradient(180deg, #767676 0%, #3b3b3b 100%);
          opacity: 1;
          border-radius: 8px;
        }
      }
      .rbottom {
        display: flex;
        height: calc(53% - 60px);
        margin-top: 6%;
        .keyBoard {
          display: flex;
          width: 85%;
          flex-wrap: wrap;
          .rlight {
            width: 53px;
            height: 33px;
            text-align: center;
            line-height: 33px;
            border: 1px solid #292929;
            background: linear-gradient(180deg, #a1a1a1 0%, #707070 100%);
            opacity: 1;
            border-radius: 6px;
            margin: 0 1% 1% 0;
          }
        }
        .keyBoard2 {
          display: grid;
          .j {
            width: 47px;
            height: 47px;
            margin-left: 24%;
            line-height: 47px;
            text-align: center;
            background: linear-gradient(1deg, #00c780 0%, #008052 100%);
            border-radius: 50%;
            opacity: 1;
            margin: 12px 18px;
          }
          .nj {
            background: #888888 !important;
          }
          .f {
            width: 78px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border: 1px solid #292929;
            background: linear-gradient(180deg, #ff534b 0%, #802a26 100%);
            opacity: 1;
            border-radius: 6px;
          }
        }
      }
    }
  }
}
</style>